function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "parts_login_mail",
  d: "M20.621,0H3.378A3.48,3.48,0,0,0,0,3.48V14.52A3.5,3.5,0,0,0,3.494,18H20.5A3.577,3.577,0,0,0,24,14.52V3.48A3.556,3.556,0,0,0,20.621,0ZM13.165,9.06h0c-.12.12-.12.12-.233.12a3.851,3.851,0,0,1-1.631,0h0l-.12-.12c-.12,0-.233-.12-.35-.12h-.12l-8.16-7.2c.35-.12.583-.12.931-.233H20.5a1.32,1.32,0,0,1,.932.348ZM9.9,10.1c.12,0,.12.12.233.12l.12.12h.12a4.895,4.895,0,0,0,1.747.456,3.11,3.11,0,0,0,1.4-.348.408.408,0,0,0,.233-.12l.12-.12,6.757,6.271H3.145Zm5.359-.929,7.11-6.156V14.864h.12a1.646,1.646,0,0,1-.233.7Zm-6.408,0L1.864,15.56a1.87,1.87,0,0,1-.35-1.045V3.48a1.044,1.044,0,0,1,.12-.581Z",
  fill: "#8498a3"
});

var SvgPartsMail = function SvgPartsMail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPartsMail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/parts_mail.36812ed9.svg";
export { ForwardRef as ReactComponent };